import { useEffect, useState } from "react"
import {
  useGetUserInsightsWithResourcesQuery,
  User_Insights,
} from "../generated/graphql"
import { UserInsightsTableData } from "../utils/types"
import { useGraphQLClient } from "./useGraphQLClient"

export const useGetUserInsights = (user_id: string) => {
  const [userInsights, setUserInsights] = useState<UserInsightsTableData[]>([])
  const graphQLClient = useGraphQLClient()
  const { data: contentData } = useGetUserInsightsWithResourcesQuery(
    graphQLClient,
    {
      user_id: user_id,
    }
  )
  const processUserInsight = (insights: User_Insights[]) => {
    const array: UserInsightsTableData[] = []
    insights.forEach((insight) => {
      const obj: UserInsightsTableData = {
        id: {
          sortData: insight.id,
          data: insight.id,
        },
        date: {
          sortData: insight.created_on,
          data: insight.created_on,
        },
        direction: {
          sortData: insight.insight_combo?.direction,
          data: insight.insight_combo?.direction,
        },
        outcome: {
          sortData: insight.insight_combo?.outcome,
          data: insight.insight_combo?.outcome,
        },
        feature: {
          sortData: insight.insight_combo?.feature,
          data: insight.insight_combo?.feature,
        },
        insight: {
          sortData: insight,
          data: insight,
        },
        display_text: {
          sortData: insight.insight_combo?.display_text ?? undefined,
          data: insight.insight_combo?.display_text ?? undefined,
        },
      }
      array.push(obj)
    })
    return array
  }
  useEffect(() => {
    const data = processUserInsight(
      (contentData?.user_insights as User_Insights[]) ?? []
    )
    setUserInsights(data)
  }, [setUserInsights, contentData?.user_insights])
  return userInsights
}
